/* eslint-disable indent */
import {
  HIRING_SUPPORT_LOADING,
  HIRING_SUPPORT_SUBMIT,
  HIRING_SUPPORT_STATUS,
  HIRING_SUPPORT_CANCEL,
  HIRING_SUPPORT_HISTORY,
  ERROR,
} from "../actionTypes";

const initialState = {
  submitting: false,
  cancelling: false,
  loadingStatus: false,
  loadingHistory: false,
  request: null,
  history: [],
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HIRING_SUPPORT_LOADING:
      return {
        ...state,
        ...payload,
      };

    case HIRING_SUPPORT_SUBMIT:
      return {
        ...state,
        request: payload
          ? {
              id: payload.request_id,
              status: payload.status,
              created_at: payload.created_at,
            }
          : null,
        error: null,
      };

    case HIRING_SUPPORT_STATUS:
      return {
        ...state,
        request: payload,
        error: null,
      };

    case HIRING_SUPPORT_CANCEL:
      return {
        ...state,
        request: payload
          ? {
              ...(state.request || {}),
              id: payload.id || state.request?.id,
              status: payload.status || "cancelled",
              cancelled_at: payload.cancelled_at,
            }
          : state.request,
        error: null,
      };

    case HIRING_SUPPORT_HISTORY:
      return {
        ...state,
        history: Array.isArray(payload) ? payload : [],
        error: null,
      };

    case ERROR:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;
  }
};
